import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

const RoundButton = ({ children, className, ...rest }) => {
  const classes = useStyles()
  return (
    <button className={clsx(classes.button, className)} {...rest}>
      {children}
    </button>
  )
}

export default RoundButton
